import { render, staticRenderFns } from "./GpCheckbox.vue?vue&type=template&id=8d40ab70&scoped=true&"
import script from "./GpCheckbox.vue?vue&type=script&lang=js&"
export * from "./GpCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./GpCheckbox.vue?vue&type=style&index=0&id=8d40ab70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d40ab70",
  null
  
)

export default component.exports